export default __webpack_public_path__ + "assets/icons/customs-inquriy.4a73e431.svg";